import { ActionCreator } from "redux";
import {
    ConnectInputToKeyboardAction,
    DisconnectKeyboardAction,
    ToggleKeyboardDisableValueAction,
    PressedKeyboardButtonAction,
    SetupEnterFunctionAction,
    ChangeKeyboardMaskAction
} from "./type";
import {
    CONNECT_KEYBOARD_TO_INPUT,
    DISCONNECT_KEYBOARD,
    TOGGLE_KEYBOARD_DISABLE_VALUE,
    SEND_KEYBOARD_VALUE,
    SETUP_ENTER_FUNCTION,
    CHANGE_KEYBOARD_MASK
} from "./constants";
import { KeyboardType } from "../../constants/keyboardTypes";

export const connectInputToKeyboard: ActionCreator<ConnectInputToKeyboardAction> = (
    pipe: (value: any) => void,
    value: string,
    mask: string,
    elementId: string,
    keyboardType: KeyboardType
) => ({
    type: CONNECT_KEYBOARD_TO_INPUT,
    payload: {
        pipe,
        value,
        mask,
        elementId,
        keyboardType
    },
});

export const disconnectKeyboard: ActionCreator<DisconnectKeyboardAction> = () => ({
    type: DISCONNECT_KEYBOARD
});

export const toggleKeyboardDisableValue: ActionCreator<ToggleKeyboardDisableValueAction> = () => ({
    type: TOGGLE_KEYBOARD_DISABLE_VALUE
});

export const pressedKeyboardButton: ActionCreator<PressedKeyboardButtonAction> = (value: string) => ({
    type: SEND_KEYBOARD_VALUE,
    payload: {
        value
    }
})

export const setupEnterFunction: ActionCreator<SetupEnterFunctionAction> = (enterFunction: () => void) => ({
    type: SETUP_ENTER_FUNCTION,
    payload: {
        enterFunction
    }
})

export const changeKeyboardMask: ActionCreator<ChangeKeyboardMaskAction> = (mask: string) => ({
    type: CHANGE_KEYBOARD_MASK,
    payload: {
        mask
    }
})


// WEBPACK FOOTER //
// ./src/store/Keyboard/actions.ts